export interface AbsenceApprovalProgressStepDto {
  StepName: string;
  StepStatus: StepStatusEnum;
  Approvals: AbsenceApprovalDto[];
}

export interface AbsenceApprovalDto {
  CreatedBy: string;
  CreatedOn: Date | null,
  IsPositive: boolean
}

export enum StepStatusEnum {
  Wait = 1,
  InactiveWait = 2,
  Done = 3,
  Rejected = 4
}